import { Navigate } from '@sorare/routing';

import { FOOTBALL_MAJOR_LEAGUE_SOCCER } from '@sorare/core/src/constants/__generated__/routes';

const MLSPage = () => {
  return <Navigate to={FOOTBALL_MAJOR_LEAGUE_SOCCER} />;
};
export default MLSPage;
